var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a;
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import addGoods from "./BindLicese/AddGoods.vue";
import addDeliverNode from "./BindLicese/AddDeliverNote.vue";
import DeliverService from '../../../api/DeliverService';
import GoodService from '../../../api/GoodService';
import { billDefaultDate } from "../../../helper/defaultDate";
import Uploader from '../../../common/components/uploader';
import { Button, Input, Form, FormItem } from 'element-ui';
import DialogVerifyOrderVue from './DialogVerifyOrder.vue';
var MulUploadLicese = (function (_super) {
    __extends(MulUploadLicese, _super);
    function MulUploadLicese() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dialogImageUrl = '';
        _this.dialogVisible = false;
        _this.deliverNodeVisible = false;
        _this.showDio = false;
        _this.showliceseDio = false;
        _this.selectGood = [];
        _this.tableFlag = '0';
        _this.imageUrl = [];
        _this.selectedNote = [];
        _this.liceseName = '';
        _this.limit = 5;
        _this.searchData = {
            s_time: billDefaultDate().Start.format('yyyy-MM-dd'),
            e_time: billDefaultDate().End.format('yyyy-MM-dd'),
            status: -1,
            keyword: '',
            time_type: 1,
            goods_name_keyword: ''
        };
        _this.FormModel = [
            {
                label: '日期',
                prop: ['s_time', 'e_time'],
                type: 'date',
                props: {
                    startTime: '开始日期',
                    endTime: '结束日期',
                }
            },
            {
                label: '状态',
                prop: 'status',
                type: 'select',
                props: {
                    placeholder: '请选择',
                    list: [
                        { id: -1, label: '全部状态' },
                        { id: 0, label: '待审核' },
                        { id: 1, label: '已审核' },
                    ]
                },
            },
            {
                label: '',
                prop: 'keyword',
                type: 'input',
                props: {
                    placeholder: _this.type == 'entrust' ? '委托送货单单号' : '送货单单号'
                },
            },
        ];
        _this.title = '选择送货单';
        _this.param = {
            goods_ids: '',
            type: '0'
        };
        _this.excludeDeliveryOrder = [];
        _this.formData = {};
        _this.listFormData = [];
        return _this;
    }
    MulUploadLicese.prototype.watchUploadLiceseShow = function (val) {
        if (val) {
            this.updateSelectNote();
        }
    };
    MulUploadLicese.prototype.watchSelectedNote = function (oldVal, newVal) {
        if (oldVal !== newVal) {
            this.selectGood = [];
        }
    };
    MulUploadLicese.prototype.created = function () {
        this.deliverService = DeliverService.getInstance();
        this.service = GoodService.getInstance();
        this.listFormData = this.$emit('listFormData');
        console.log(122, this.searchData);
    };
    MulUploadLicese.prototype.updateSelectNote = function () {
        var _this = this;
        var ids = this.selectedRows.map(function (item) {
            return item.order_id;
        });
        var uniqueIds = Array.from(new Set(ids.flat()));
        if (!uniqueIds.length) {
            this.selectedNote = [];
            return;
        }
        var func = this.type == 'entrust' ? this.deliverService.getEntrustdeliverNote : this.deliverService.getdeliverNote;
        var format = 'YYYY-MM-DD';
        var params = {
            status: -1,
            s_time: '',
            e_time: '',
            page: 1, start: 0, limit: 999999, in: String(uniqueIds)
        };
        console.log('updateSelectNote>>>', ids, uniqueIds, params);
        func(params).then(function (res) {
            console.log('res>>>', res);
            _this.selectedNote = res.data.data;
        });
    };
    MulUploadLicese.prototype.getDeliveryIds = function (isValid) {
        if (isValid === void 0) { isValid = true; }
        var list = this.selectGood || [];
        var exclude = this.excludeDeliveryOrder;
        var filter = function (item) {
            return !exclude.some(function (e) { return e.delivery_order_id === item.delivery_order_id; });
        };
        return list.map(function (item) {
            var list = Array.isArray(item.selected_deliver_order) && item.selected_deliver_order.length ? item.selected_deliver_order : item.deliver_order_items;
            if (isValid) {
                return list.map(function (s) { return s.order_detail_id; });
            }
            return list.filter(filter).map(function (s) { return s.delivery_order_id; });
        }).flat();
    };
    MulUploadLicese.prototype.updated = function () {
        this.listFormData = this.$emit('listFormData');
        this.searchData.s_time = this.listFormData.searchData.s_time;
        this.searchData.e_time = this.listFormData.searchData.e_time;
        console.log(222, this.searchData, this.listFormData);
    };
    MulUploadLicese.prototype.verifyUploadedOrder = function () {
        var _this = this;
        return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var params;
            var _this = this;
            return __generator(this, function (_a) {
                params = {
                    delivery_order_detail_ids: this.getDeliveryIds().join(',')
                };
                console.log('verifyUploadedOrder params>>>', params);
                this.deliverService.getUploadedDeliver(params)
                    .then(function (res) {
                    var list = res.data.data || [];
                    if (list.length) {
                        _this.$refs.verifyOrder
                            .set('list', list)
                            .show();
                        reject();
                    }
                    else {
                        resolve();
                    }
                }, function (err) {
                    console.log('verifyUploadedOrder err>>>', err);
                    resolve();
                });
                return [2];
            });
        }); });
    };
    MulUploadLicese.prototype.handleVerifyConfirm = function (_a) {
        var all = _a.all, selected = _a.selected;
        var filter = function (item) {
            return !selected.some(function (s) { return s.delivery_order_id === item.delivery_order_id; });
        };
        this.excludeDeliveryOrder = all.filter(filter);
        console.log('handleVerifyConfirm rows>>>', this.excludeDeliveryOrder, all, selected);
        this.saveLicese(false);
    };
    MulUploadLicese.prototype.saveLicese = function (valid) {
        if (valid === void 0) { valid = true; }
        return __awaiter(this, void 0, void 0, function () {
            var uploaderRef, uploadRef, uploadFiles, hasUploadingFiles, hasUnuploadedFiles, document_pic, delivery_order_map, param;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!valid) return [3, 2];
                        return [4, this.verifyUploadedOrder()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (this.selectedNote.length == 0) {
                            this.$message.error('请至少选择一项送货单');
                            return [2];
                        }
                        if (this.liceseName == '') {
                            this.$message.error('请输入证照名称');
                            return [2];
                        }
                        if (this.liceseName.length > 20) {
                            this.$message.error('证照名称限20字内数字、字母、汉字、特殊符号');
                        }
                        uploaderRef = this.$refs.uploader;
                        if (uploaderRef && uploaderRef.$refs && uploaderRef.$refs.upload) {
                            uploadRef = uploaderRef.$refs.upload;
                            uploadFiles = uploadRef.uploadFiles;
                            console.log('所有上传文件（包括正在上传的）：', uploadFiles);
                            hasUploadingFiles = uploadFiles.some(function (file) {
                                return file.status === 'uploading' ||
                                    file.status === 'ready' ||
                                    (file.percentage !== undefined && file.percentage < 100);
                            });
                            if (hasUploadingFiles) {
                                this.$message.warning('文件正在上传中，请上传完成后再操作！');
                                return [2];
                            }
                        }
                        if (this.imageUrl.length == 0) {
                            this.$message.error('请上传证照图片');
                            return [2];
                        }
                        hasUnuploadedFiles = this.imageUrl.some(function (item) {
                            if (item.url && item.url.startsWith('blob:')) {
                                return true;
                            }
                            if (item.status && item.status !== 'success') {
                                return true;
                            }
                            if (!item.response && (!item.url || !item.url.startsWith('http'))) {
                                return true;
                            }
                            return false;
                        });
                        if (hasUnuploadedFiles) {
                            this.$message.warning('文件正在上传中，请上传完成后再操作！');
                            return [2];
                        }
                        document_pic = this.imageUrl
                            .filter(function (item) { return item.url && item.url.startsWith('http'); })
                            .map(function (item) { return item.url; });
                        if (document_pic.length === 0) {
                            this.$message.warning('没有有效的文件，请重新上传');
                            return [2];
                        }
                        if (document_pic.length !== this.imageUrl.length) {
                            this.$message.warning('部分文件尚未上传完成，请稍候再试！');
                            return [2];
                        }
                        delivery_order_map = this.selectedNote.map(function (item) {
                            return {
                                delivery_order_id: item.delivery_order_id,
                                delivery_order_detail_id: item.order_detail_id
                            };
                        });
                        param = {
                            document_name: this.liceseName,
                            document_pic: document_pic,
                            goods_ids: [],
                            supplier_goods_ids: [],
                            delivery_order_map: delivery_order_map,
                            delivery_order_ids: this.getDeliveryIds(false)
                        };
                        if (this.tableFlag - 0 === 0) {
                            param.goods_ids = this.selectGood.map(function (item) { return item.goods_id; });
                        }
                        else {
                            param.supplier_goods_ids = this.selectGood.map(function (item) { return item.goods_id; });
                        }
                        this.deliverService.saveLicese(param).then(function (res) {
                            console.log(res.data);
                            if (res.data.code == 0) {
                                _this.$emit('cancelDio', false);
                                _this.InitData();
                                _this.$message.success(res.data.msg);
                            }
                        }).catch(function (err) {
                            _this.$message.error(err.msg || err.message);
                        });
                        return [2];
                }
            });
        });
    };
    MulUploadLicese.prototype.cancel = function () {
        this.InitData();
        this.$emit('cancelDio', false);
    };
    MulUploadLicese.prototype.handleRemove = function (file, fileList) {
        console.log(file, fileList);
    };
    MulUploadLicese.prototype.handlePictureCardPreview = function (file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
    };
    MulUploadLicese.prototype.handleAvatarSuccess = function (res, file) {
        this.imageUrl.push({ url: res.data.full_path });
    };
    MulUploadLicese.prototype.selectGoods = function () {
        var _this = this;
        console.log(111, this.selectGood);
        if (!this.selectedNote.length) {
            return this.$message.warning("\u8BF7\u5148" + (this.type == 'entrust' ? '选择委托送货单' : '选择送货单'));
        }
        var dialog = this.$dialog(addGoods, {
            data: {
                type: this.type,
                tableFlag: this.tableFlag,
                addedDatas: _.cloneDeep(this.selectGood),
                selectedOrders: _.cloneDeep(this.selectedNote),
                orderIds: this.selectedNote.map(function (item) { return item.delivery_order_id; }),
            }
        }, {
            title: "选择货品",
            width: 1150,
            height: 650,
            zIndex: 2100,
        });
        dialog.instance.$on("save:ok", function (row, tableFlag) {
            console.log('selectGoods>>>', row);
            _this.selectGood = row;
            _this.tableFlag = tableFlag;
        });
    };
    MulUploadLicese.prototype.selectNote = function () {
        this.title = this.type == 'entrust' ? '选择委托送货单' : '选择送货单';
        var handleParam = [];
        handleParam = this.selectGood.map(function (item) {
            return item.goods_id;
        });
        console.log(11211, this.selectGood, handleParam, this.tableFlag);
        this.param.goods_ids = handleParam.join(',');
        this.param.type = this.tableFlag;
        this.showDio = true;
        this.deliverNodeVisible = true;
    };
    MulUploadLicese.prototype.closeDiolog = function () {
        this.showDio = false;
        this.deliverNodeVisible = false;
        this.searchData = {
            s_time: billDefaultDate().Start.format('yyyy-MM-dd'),
            e_time: billDefaultDate().End.format('yyyy-MM-dd'),
            status: -1,
            time_type: 1,
            keyword: ''
        };
    };
    MulUploadLicese.prototype.save = function (data) {
        this.selectedNote = data;
        this.showDio = false;
        this.deliverNodeVisible = false;
        console.log('save>>>', data);
    };
    MulUploadLicese.prototype.InitData = function () {
        this.selectGood = [];
        this.param.goods_ids = '';
        this.param.type = '0';
        this.liceseName = '';
        this.imageUrl = [];
    };
    __decorate([
        Prop({
            type: String,
            default: ''
        })
    ], MulUploadLicese.prototype, "type", void 0);
    __decorate([
        Prop({
            type: Array,
            default: []
        })
    ], MulUploadLicese.prototype, "selectedRows", void 0);
    __decorate([
        Prop({
            type: Boolean,
            default: false,
        })
    ], MulUploadLicese.prototype, "uploadLiceseShow", void 0);
    __decorate([
        Prop({
            type: Object,
            default: {}
        })
    ], MulUploadLicese.prototype, "formData", void 0);
    __decorate([
        Watch('uploadLiceseShow')
    ], MulUploadLicese.prototype, "watchUploadLiceseShow", null);
    __decorate([
        Watch('selectedNote')
    ], MulUploadLicese.prototype, "watchSelectedNote", null);
    MulUploadLicese = __decorate([
        Component({
            computed: {},
            components: (_a = {
                    'addDeliverNode': addDeliverNode,
                    uploader: Uploader
                },
                _a[Button.name] = Button,
                _a[Input.name] = Input,
                _a[Form.name] = Form,
                _a[FormItem.name] = FormItem,
                _a.DialogVerifyOrderVue = DialogVerifyOrderVue,
                _a)
        })
    ], MulUploadLicese);
    return MulUploadLicese;
}(Vue));
export default MulUploadLicese;
